// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blitzle: PokeData = {
  "id": 522,
  "name": "blitzle",
  "height": 8,
  "weight": 298,
  "base_experience": 59,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "stomp",
    "thrash",
    "tail-whip",
    "thunder-wave",
    "agility",
    "quick-attack",
    "spark",
    "pursuit",
    "charge",
    "shock-wave",
    "discharge",
    "flame-charge",
    "wild-charge"
  ],
  "moves": [
    "quick-attack",
    "pursuit",
    "wild-charge",
    "thunder-shock",
    "thunder-punch",
    "volt-switch",
    "electric-wrath",
    "thunder-fang",
    "electric-terrain",
    "thunder",
    "volt-crash",
    "thunderbolt",
    "zap-cannon"
  ],
  "evolution_chain": {
    "id": 267,
    "item": null,
    "species": [
      {
        "name": "blitzle",
        "order": 523,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "zebstrika",
        "order": 524,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 522,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 38.5,
    "speed": 76,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
